import { Notification } from "types/notification"

export function saveNotificationsInLocalStorage(notifications: Notification[]) {
	localStorage.setItem("notificationsData", JSON.stringify(notifications))
}
